module.exports = __webpack_public_path__ + "static/media/Reimbursement.ecc5b34c.svg";